import React, { useState } from 'react';
import { Card, CardContent } from './ui/card';
import { ChevronDown } from 'lucide-react';
import { faqIntro, faqItems } from '../data/faqData';

const FAQSection = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const faqs = faqItems;

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
      <div className="mb-12">
        <h2 className="text-3xl md:text-4xl font-bold mb-4 text-foreground">FAQ</h2>
        <p className="text-muted-foreground max-w-3xl leading-relaxed">{faqIntro}</p>
      </div>

      <div className="space-y-4">
        {faqs.map((faq, index) => (
          <Card
            key={index}
            className="bg-card/50 border-border/50 hover:border-accent/30 transition-all duration-300 cursor-pointer"
            onClick={() => toggleFAQ(index)}
          >
            <CardContent className="p-6">
              <div className="flex items-start justify-between gap-4">
                <h3 className="text-lg font-semibold text-foreground pr-8">
                  {index + 1}. {faq.question}
                </h3>
                <ChevronDown
                  className={`w-5 h-5 text-muted-foreground flex-shrink-0 transition-transform duration-300 ${
                    openIndex === index ? 'transform rotate-180' : ''
                  }`}
                />
              </div>
              {openIndex === index && (
                <div className="mt-4 pt-4 border-t border-border/50">
                  <p className="text-muted-foreground leading-relaxed">{faq.answer}</p>
                </div>
              )}
            </CardContent>
          </Card>
        ))}
      </div>
    </section>
  );
};

export default FAQSection;

